export enum RouteState {
  Sandbox = 0,
  "Nwp Recheck" = 1,
  "Plant Confirmation" = 2,
  "Odc Confirmation" = 3,
  "Supplier Confirmation" = 4,
  "Carrier Confirmation" = 5,
  "Carrier Manager" = 7,
  "Ready for launch" = 8,
  Launched = 10,
  "Pending Launch" = 12,
  "Re-Launch" = 13,
  "Interim Launch" = 14,
  "Inbound Expired" = 15,
  "De-Launched" = 16,
}

export function GetRouteStateDisplayName(routeState: RouteState | undefined) {
  if (routeState !== undefined) return RouteState[routeState];
}

export const routeStateAsString = new Map([
  [RouteState.Sandbox, "Sandbox"],
  [RouteState["Nwp Recheck"], "Nwp Recheck"],
  [RouteState["Plant Confirmation"], "Plant Confirmation"],
  [RouteState["Odc Confirmation"], "Odc Confirmation"],
  [RouteState["Supplier Confirmation"], "Supplier Confirmation"],
  [RouteState["Carrier Confirmation"], "Carrier Confirmation"],
  [RouteState["Carrier Manager"], "Carrier Manager"],
  [RouteState["Ready for launch"], "Ready for launch"],
  [RouteState.Launched, "Launched"],
  [RouteState["Pending Launch"], "Pending Launch"],
  [RouteState["Re-Launch"], "Re-Launch"],
  [RouteState["Interim Launch"], "Interim Launch"],
  [RouteState["De-Launched"], "De-Launched"],
]);
